module.exports = __webpack_public_path__ + "static/img/43205-200.df83e9a1.png";